// extracted by mini-css-extract-plugin
export default {"root":"ny9i7ERCgHC8zJxE5l3U","issue-reported":"Gik18xfYvKpsu_CySfDO","issue-reported__phone":"YCLeBK_vrSbshsvuWcAc"};